
import styles from '../style.module.css';
import lang from "../../../lang/lang";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const FALLBACK_TEXT = {
    hy: "Միացիր մեր թիմին և դարձիր ՎԻԷԼՎԻ մեծ ընտանիքի մաս։ Մենք առաջարկում ենք աշխատանքային հնարավորություններ, մասնագիտական աճ և ժամանակակից միջավայր՝ այն մարդկանց համար, ովքեր սիրում են տեխնիկան և հաճախորդների սպասարկումը։",
    ru: "Присоединяйтесь к нашей команде и станьте частью большой семьи VLV. Мы предлагаем карьерные возможности, профессиональный рост и современную среду для тех, кто любит технику и работу с клиентами.",
    en: "Join our team and become part of the VLV family. We offer career opportunities, professional growth, and a modern workplace for people who love technology and customer care.",
};

function stripHtml(html = "") {
    return html.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();
}

function Members({ image, title, text, link, linkText }) {

    const { currentLanguage } = useSelector(({ main }) => main);
    const navigate = useNavigate();

    const hasText = Boolean(stripHtml(text));
    const buttonLabel = stripHtml(linkText) || lang[currentLanguage]?.view_more;
    const target = link || "/job";

    return (
        <div className={styles.members_section}>
            <div className={styles.members_foto}>
                <img
                    src={image}
                    alt = { 'vlv team photo' }
                />
            </div>
            <div className={styles.members_text_link_content}>
                <h2> { title } </h2>
                {hasText ? (
                    <div
                        className={styles.members_text}
                        dangerouslySetInnerHTML={{ __html: text }}
                    />
                ) : (
                    <p className={styles.members_text}>
                        {FALLBACK_TEXT[currentLanguage] || FALLBACK_TEXT.en}
                    </p>
                )}
                <button
                    className={styles.members_link}
                    onClick={() => navigate(target)}
                >
                    { buttonLabel }
                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11" fill="none">
                        <path d="M0.750037 0.75L5.25 5.25002L0.75 9.75002" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="16" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
            </div>
        </div>
    )
}

export default Members
